/**
 * 会员API配置
 * lixian
 */
const api = [
 {
  name: 'memberList',
  method: 'POST',
  desc: '会员列表',
  path: '/findCrmInfo',
  mock: false,
  params: {
    pageNum: 1,
    pageSize: 25,
    crmdataStatus: 0,
    orgdataStatus: 0,
    accountName: null
  }
},
{
  name: 'hadAuditedList',
  method: 'GET',
  desc: '已审核列表',
  path: '/hadAuditedList',
  mock: false,
  params: {
    authenType: '',
    accountName: ''
  }
},
{
  name: 'sumitAudit',
  method: 'POST',
  desc: '审核通过/不通过',
  path: '/sumitAudit',
  mock: false,
  params: {
    authenType: '',
    id: '',
    dataStatus: '',
    auditOpinion: ''
  }
},
{
  name: 'waitModifyList',
  method: 'GET',
  desc: '已审核列表',
  path: '/waitModifyList',
  mock: false,
  params: {
    authenType: '',
    accountName: ''
  }
},
{
  name: 'audit',
  method: 'GET',
  desc: '获取审核详细信息审核',
  path: '/audit',
  mock: false,
  params: {
    id: '',
    authenType: ''
  }
},
{
  name: 'hadAuditedDetail',
  method: 'GET',
  desc: 'v4.3.3sp2 会员审核-已审核详情',
  path: '/hadAuditedDetail',
  mock: false,
  params: {
    id: '',
    authenType: '',
    orgId: '',
    transferId: ''
  }
},
{
  name: 'waitModifyDetail',
  method: 'GET',
  desc: 'v4.3.3sp2 会员审核-待修正详情',
  path: '/waitModifyDetail',
  mock: false,
  params: {
    id: '',
    orgId: '',
  }
},
{
  name: 'authonList',
  method: 'GET',
  desc: '会员审核-待审核列表',
  path: '/authonList',
  mock: false,
  params: {
    authenType: '',
    accountName: ''
  }
},
{
  name: 'crmDetailInfo',
  method: 'GET',
  desc: '会员详细信息',
  path: '/getMemberInfo',
},
{
  name: 'uploadBizFile',
  method: 'POST',
  desc: '供货授权协议上传',
  path: '/uploadBizFile'
},
{
  name: 'uploadCenBizFile',
  method: 'POST',
  desc: '集采-协议上传',
  path: '/uploadCenBizFile'
},
{
  name: 'expFindCrmInfo',
  method: 'POST',
  desc: '会员查询导出Excel',
  path: '/expFindCrmInfo'
},
{
  name: 'findSameSelfCrmInfo',
  method: 'POST',
  desc: '查看相同自建企业',
  path: '/findSameSelfCrmInfo',
},
{
  name: 'sumitAudit',
  method: 'POST',
  desc: '审核通过（历史接口）',
  path: '/sumitAudit',
}
]

export default {
  BASE_URL: '/sysCrmMember',
  NAMESPACE: 'crmMember',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/member/member-query.js